import { CAARepository } from '../repositories/CAARepository'

export function ListCustomCAAReport(caaRepositoryAdapter: CAARepository) {
  return async function ({
    patientId,
    startDate,
    endDate
  }: {
    patientId: string
    startDate: string
    endDate: string
  }) {
    return await caaRepositoryAdapter.listCustomCAAReport(
      patientId,
      startDate,
      endDate
    )
  }
}
